<template>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-24 mb-24">
    <div class="p-8 bg-gray-100 text-gray-800">
      <h1 class="text-3xl font-bold mb-4">Nosotros</h1>
      <p class="mb-4">
        En Pisu Store, somos una tienda peruana apasionada por el mundo e-sports. Nos especializamos en la fabricación y personalización de prendas inspiradas en los videojuegos más populares, como League of Legends, y otros títulos emblemáticos del universo competitivo.
      </p>
      <h2 class="text-2xl font-semibold mb-2">Calidad y precisión en cada detalle</h2>
      <p class="mb-4">
        Desde Perú, ofrecemos productos fieles a los diseños originales, cuidando cada detalle para garantizar una prenda que cumpla con las expectativas de los verdaderos fanáticos. Utilizamos materiales de alta calidad, asegurando durabilidad, comodidad y estilo en cada una de nuestras creaciones.
      </p>
      <h2 class="text-2xl font-semibold mb-2">Compromiso con nuestros clientes</h2>
      <p class="mb-4">
        Sabemos lo importante que es para un jugador vestir una camiseta, chaqueta o uniforme que represente su pasión por los e-sports. Es por eso que trabajamos con dedicación y creatividad, fusionando tecnología textil y diseño innovador para brindar un producto único y auténtico.
      </p>
      <h2 class="text-2xl font-semibold mb-2">Orgullo peruano en el mundo e-sports</h2>
      <p class="mb-4">
        Estamos orgullosos de representar a Perú en la industria textil y de contribuir al crecimiento del mercado e-sports con productos que combinan nuestra pasión, talento y compromiso con la excelencia.
      </p>
      <h2 class="text-2xl font-semibold mb-2">Contáctanos</h2>
      <p class="mb-2">📱 Teléfono/WhatsApp: +51 949234215</p>
      <p class="mb-2">📧 Correo electrónico: <a href="mailto:shop@pisustore.com" class="underline text-blue-500">shop@pisustore.com</a></p>
      
    </div>
</div>
  </template>
  
  <script>
  export default {
    name: 'NosotrosPage'
  }
  </script>
  
  <style scoped>
  /* Puedes agregar estilos adicionales aquí si es necesario */
  </style>